<template>
  <el-select
    v-model="valueBackup"
    filterable
    :remote="remote"
    :remote-method="search"
    :clearable="clearable"
    :multiple="multiple"
    @change="handleChange"
    @focus="handleFocus"
    :placeholder="placeholder"
    :size="size"
    :collapse-tags="collapse"
    :class="`${clearable ? '' : 'is-not-clearable'}`"
  >
    <v-avatar-option :value="listBackup" uni-key="TeacherAvatarOption"/>
  </el-select>
</template>

<script>
import { index } from '@/api/teacher';
import { mapGetters } from 'vuex';

export default {
  props: {
    value: [Number, String, Array],
    storeId: [Number, String, Array],
    size: {
      type: String,
      default: 'medium',
    },
    placeholder: {
      type: String,
      default: '输入昵称或手机号搜索老师',
    },
    list: {
      type: Array,
      default: () => [],
    },
    multiple: Boolean,
    clearable: Boolean,
    remote: Boolean,
    collapse: Boolean,
  },
  data: () => ({
    valueBackup: [],
    listBackup: [],
    teachers: [],
    timer: 0,
    isGettingList: false,
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== this.valueBackup) this.valueBackup = +value || '';
      }
      this.getList(this.storeId);
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
      }
    },
    storeId(storeId) {
      this.getList(storeId);
    },
    list(list) {
      if (JSON.stringify(list) === JSON.stringify(this.listBackup)) return;
      this.listBackup = list;
      this.teachers = list;
      this.getTeacherBrief();
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  methods: {
    async getTeacherBrief() {
      const isArray = typeof this.valueBackup === 'object';
      if (isArray && !this.valueBackup.length) return;
      if (!isArray && !this.valueBackup) return;

      const { listBackup } = this;
      if (listBackup.length) {
        let { length } = listBackup;

        for (let i = 0; i < length; i++) {
          if (isArray) {
            if (this.valueBackup.includes(listBackup[i].id)) return;
          } else {
            if (this.valueBackup === listBackup[i].id) return;
          }
        }
      }

      const { isError, data } = await index({
        teacher_ids: isArray ? this.valueBackup : [this.valueBackup]
      });
      this.isGettingList = false;
      if (isError) return;
      this.teachers = data;
      this.listBackup = data;
    },
    async getList(store_id) {
      if (this.isGettingList) return;
      this.isGettingList = true;
      if (!store_id) return this.getTeacherBrief();

      store_id = store_id ? +store_id : 0;
      const { isError, data } = await index({
        store_id,
        is_brief: 1,
      });
      if (!isError) {
        this.teachers = data
        this.listBackup = data;
      }

      this.getTeacherBrief();
    },
    async search(keyword) {
      if (!keyword) return;
      const { isError, data } = await index({ store_id: this.storeId, keyword, is_brief: 1 });
      if (!isError) this.listBackup = data || [];
    },
    removeDuplicates(arr) {
      const uniqueIds = new Set(); // 用于存储唯一的 id 值
      return arr.filter(obj => {
        if (!uniqueIds.has(obj.id)) {
          uniqueIds.add(obj.id);
          return true;
        }
        return false;
      });
    },
    handleChange(valueBackup) {
      if (typeof valueBackup !== 'object') return;

      const listTeachers = [];
      valueBackup.forEach((teacher_id) => {
        this.listBackup.forEach((teacher) => {
          if (teacher.id === teacher_id) listTeachers.push(teacher);
        });
      });

      const allTeachers = this.teachers.concat(listTeachers);
      const l = allTeachers.length;
      const teachers = [];

      for (let i = 0; i < l; i++) {
        let isSet = false;
        let teacher = allTeachers[i];
        let { id } = teacher;
        for (let j = 0; j < valueBackup.length; j++) {
          if (id === valueBackup[j]) {
            isSet = true;
            break;
          }
        }
        if (isSet) teachers.push(teacher);
      }

      this.teachers = this.removeDuplicates(teachers);
      this.$emit('change', this.teachers);
    },
    handleFocus() {
      if (this.teachers.length) this.listBackup = this.teachers;
    },
    setTimeGetList() {// 用于解决只显示 id，没有获取老师列表的问题
      if (!this.timer || this.listBackup.length) return;

      clearTimeout(this.timer);
      this.timer = 0;
      this.getList(this.storeId);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      this.valueBackup = +this.value || '';
    }

    if (this.list.length) {
      this.listBackup = this.teachers = this.list;
      this.getTeacherBrief();
      return;
    }

    this.getList(this.storeId);
    this.timer = setTimeout(this.setTimeGetList, 3000);
  },
};
</script>
